import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY

export const INITIAL_COT_DATA = {
    fechaInicial: '',
    fechaFinal: '',
    origen: '',
    destino: '',
    direccionOrigen: '',
    direccionDestino: '',
    referencia: '',
    totalPasajeros: null,
    fuente: '',
    cliente: '',
    clasificacion: '',
    nombre: '',
    telefono: '',
    email: '',
    estatus: 20
}

export const getDestinationOptions = async () => {
    try {
        const result = await api.get(`${urlApi}/sumaTravel/getDestinationOptions`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}


export const getOptions = async () => {
    try {
        const result = await api.get(`${urlApi}/sumaTravel/getOptions`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const getCotById = async (id) => {
    try {
        const result = await api.get(`${urlApi}/sumaTravel/getCotById?id=${id}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const getCotList = async (date, estatus = []) => {
    try {
        const start = `${date.start.value.toISOString().split('T')[0]} 00:00:00`;
        const end = `${date.end.value.toISOString().split('T')[0]} 23:59:59`;

        // Construir query params
        let url = `${urlApi}/sumaTravel/getCotList?start=${start}&end=${end}`;

        // Agregar estatus solo si hay seleccionados
        if (estatus.length > 0) {
            const estatusIds = estatus.map(e => e.key).join(',');
            url += `&estatus=${estatusIds}`;
        }

        const result = await api.get(url);
        return result.data;

    } catch (error) {
        console.log("Error al obtener cotizaciones:", error);
        throw error;
    }
}


export const addQuotation = async (data) => {
    try {
        const result = await api.post(`${urlApi}/sumaTravel/addQuotation`, data);
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw error;
    }
}
export const updateQuotation = async (id, data) => {
    try {
        const result = await api.post(`${urlApi}/sumaTravel/updateQuotation?id=${id}`, data);
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw error;
    }
}
export const chooseQuotation = async (idCot, idTransporte) => {
    try {
        const result = await api.post(`${urlApi}/sumaTravel/chooseQuotation`, {idCot, idTransporte});
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw error;
    }
}

export const uploadPDF = async (formData, year, month) => {
    try {
        const res = await api.post(`${urlApi}/sumaTravel/uploadFile?year=${year}&month=${month}`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
        return res.data
    } catch (error) {
        console.error("Error al subir archivo", error);
    }
};


export const removeQuotation = async (id, quotationId) => {
    try {
        const result = await api.post(`${urlApi}/sumaTravel/${id}/quotation/${quotationId}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw error;
    }
}
